<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import { showDialog, showSnackbar } from "@/UIHelper";
import { AufgabeStatusZuordnung, AufgabeStatusFrame } from "../ChartTypesAndFunctions";
import { onShowSite, refreshFullPageContent } from "@/NavigationHelper";
import CalcButton from "@/components/CalcButton.vue";
import BaseApiAufruf from "@/views/Base/ApiAufruf.vue";
const props = defineProps<{
  showButtons?: boolean;
  zuordnungen?: AufgabeStatusZuordnung[];
  aic?: number;
  persoenlich?: boolean;
  onlyVector?: boolean;
  vector?: number[];
  zeitbereich?: APIZeitbereich;
  printItems?: ALLDruck[];
  modellItems?: ALLModell[];
  exportItems?: AbfrageItems[];
  ausPlanung?: boolean;
  vectorPlanung?: any[];
  noSelect?: boolean;
  vectorTable?: any[];
  color?: string;
  right?: -30;
  top?: 0;
  ausPlanungVG?: boolean;
  kpi?: boolean;
}>();
const emit = defineEmits<{
  (event: "onReloadData", valid?: boolean): void;
}>();
let onlyVectorMutable = ref<boolean>(false);
let vectorMutable = ref<number[]>();

let drucke = ref<ALLDruck[]>([]);
let modelle = ref<ALLModell[]>([]);
let frame: AufgabeStatusFrame[] = [];
let showExport = ref<boolean>(false);
const showMenuDrucke = ref(false);
const showMenuModelle = ref(false);

onMounted(() => {
  onlyVectorMutable.value = props.onlyVector;
  vectorMutable.value = props.vector;
  if (props.zuordnungen && props.zuordnungen.length > 0) {
    drucke.value = props.zuordnungen
      ?.filter((z) => z.gruppe === "Druck")
      .map((z) => z as ALLDruck);
    drucke.value = drucke.value.sort(dynamicSort("bezeichnung"));
    modelle.value = props.zuordnungen
      ?.filter((z) => z.gruppe === "Modell")
      .map((z) => z as ALLModell);
    if (!props.kpi) {
      // subFormulare darf ich im DS beim KPI nicht anzeigen..
      frame = props.zuordnungen
        ?.filter((z) => z.gruppe === "Frame")
        .map((z) => z as AufgabeStatusFrame);
    }
  } else {
    drucke.value = props.printItems ?? [];
    modelle.value = props.modellItems ?? [];
  }
  if (props.vectorTable && props.vectorTable.length > 0) {
    // props.vector = [];
    const vecStamm: any[] = [];
    props.vectorTable.forEach((element) => {
      vecStamm.push(element.aic_Stamm ?? element.aic_Bew_pool);
    });
    vectorMutable.value = vecStamm;
    onlyVectorMutable.value = true;
  } else if (
    props.vectorPlanung &&
    props.vectorPlanung.length > 0 &&
    props.ausPlanungVG
  ) {
    vectorMutable.value = [];
    const vecStamm: any[] = [];
    props.vectorPlanung.forEach((element) => {
      vecStamm.push(element.GroupID);
    });

    vectorMutable.value = vecStamm;
    onlyVectorMutable.value = true;
  }
});
function dynamicSort(property: any) {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return (a: any, b: any) => {
    const result =
      a[property].localeCompare < b[property].localeCompare
        ? -1
        : a[property].localeCompare > b[property].localeCompare
        ? 1
        : 0;
    return result * sortOrder;
  };
}
function getStyle() {
  if (props.kpi) {
    return {
      padding: 0,
    };
  }
  if (props.aic) {
    return {
      // height: 0,
      // position: "absolute",
      // "margin-top": top + "px",
      // "margin-right": right + "px"
    };
  }
  return {
    padding: 0,
    // height: "40px"
    // display: "inline-block",
    // width: "60%",
  };
}

function openDruckVorschau(item: ALLDruck) {
  const printItem = item;
  let aicLocal = AUApi.Current.user.aic;
  // aic kann von den Aufträgen übergeben werden (CChart)

  if (props.aic && typeof props.aic !== "object") {
    aicLocal = props.aic;
  }
  const vecStamm = props.vector ?? []; // vecStamm;
  if (props.onlyVector && vecStamm.length === 0 && !props.aic) {
    showSnackbar({
      text: "Bitte wählen Sie zuerst einen Datensatz aus!",
      color: "warning",
    });
    // console.log("keine Satz markiert");
    return;
  } else if (typeof props.aic === "object") {
    showSnackbar({
      text: "Bitte wählen Sie zuerst einen Datensatz aus!",
      color: "warning",
    });
    return;
  }
  let fullscreen = false;
  // console.log("isPhone: " + $isPhone());
  // if (Constants.isMobile && $isPhone()) {
  //   fullscreen = true;
  // }
  const pers = item.pers;
  showDialog({
    title: printItem.bezeichnung,
    site: "BaseDruck",
    width: 500,
    fullscreen,
    data: {
      zeitbereich: props.zeitbereich,
      printItem,
      aic: aicLocal,
      vecStamm,
      pers,
      noSelect: props.noSelect,
      vectorPlanung: props.vectorPlanung,
      ausPlanung: props.ausPlanung,
      ausPlanungVG: props.ausPlanungVG,
    },
    onClose: () => {
      return true;
    },
  });
}
function openFrame(item: any) {
  const aic = props.aic;
  const site = item.alias ?? item.kennung;
  onShowSite({
    title: item.name,
    site,
    data: {
      zeitbereich: AUApi.Current.zeitbereich,
      item,
      aic,
      showBack: true,
      toggleUebergabe: item.toggleSight, // hab noch keine Definition... fehlt noch
      name: item.name,
      titel: item.name,
      gotoToday: false,
    },

    callOnLeave: () => {
      setTimeout(() => refreshFullPageContent());
    },
  });
}
function onCalculated(args: any) {
  // nach der Berechnung alles neu laden!
  if (args === undefined) {
    return;
  }
  if (props.ausPlanungVG) {
    emit("onReloadData");
  } else {
    setTimeout(() => refreshFullPageContent());
  }
  closeOnOutside.value = true;
}
const closeOnOutside = ref(true);
</script>
<template>
  <div :style="getStyle()">
    <div
      v-if="
        !props.showButtons &&
        (drucke?.length > 0 || modelle?.length > 0 || frame?.length > 0)
      "
    >
      <v-menu
        v-model="showMenuDrucke"
        :close-on-content-click="false"
        @click:outside="showMenuDrucke = false"
      >
        <template v-slot:activator="{ props }">
          <v-fab-transition>
            <v-btn size="small" v-bind="props" class="pa-0">
              <v-icon size="medium" color="grey">mdi-dots-vertical</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>
        <v-list>
          <v-list-group :value="drucke" v-if="drucke.length > 0">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                title="Drucke"
                prepend-icon="mdi-printer"
              ></v-list-item>
            </template>
            <v-list-item
              v-for="(item, index) in drucke"
              :key="index"
              @click="openDruckVorschau(item)"
            >
              <v-tooltip location="bottom" :text="item.tooltip">
                <template v-slot:activator="{ props }">
                  <v-list-item-title v-bind="props">
                    {{ item.bezeichnung }}
                  </v-list-item-title>
                </template>
              </v-tooltip>
            </v-list-item>
          </v-list-group>
          <v-list-group
            title="Modelle"
            :value="modelle"
            v-if="modelle.length > 0"
            prepend-icon="mdi-play-circle-outline"
          >
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" title="Modelle"></v-list-item>
            </template>
            <v-list-item v-for="(modellItem, index) in modelle" :key="index">
              <CalcButton
                @onCalculate="closeOnOutside = false"
                :text="modellItem.bezeichnung"
                :modell="modellItem.kennung"
                :icon="modellItem.icon ?? 'mdi-play-circle-outline'"
                :color="modellItem.farbe"
                variant="plain"
                :vecStamm="vectorMutable"
                @calculated="onCalculated"
                :zeitbereich="props.zeitbereich"
              />
            </v-list-item>
          </v-list-group>

          <v-list v-if="frame && frame.length > 0">
            <v-list-item v-for="(item, index) in frame" :key="'p' + index">
              <!-- <v-btn variant="text" @click="openFrame(item)" icon="mdi-open-in-new">
                {{ item.bezeichnung }}</v-btn
              > -->

              <v-list-item-title
                v-bind="props"
                class="d-flex align-center ga-2"
                @click="openFrame(item)"
              >
                <v-icon size="small">mdi-open-in-new</v-icon>
                <span>{{ item.bezeichnung }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list>
      </v-menu>
    </div>
    <div v-if="props.showButtons">
      <v-menu :close-on-content-click="false" v-if="drucke && drucke.length > 0">
        <template v-slot:activator="{ props }">
          <v-btn
            variant="text"
            v-bind="props"
            icon="mdi-printer-outline"
            :base-color="color ?? 'black'"
          ></v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in drucke"
            :key="'p' + index"
            @click="openDruckVorschau(item)"
          >
            <v-tooltip location="bottom" :text="item.tooltip">
              <template v-slot:activator="{ props }">
                <v-list-item-title v-bind="props">
                  {{ item.bezeichnung }}
                </v-list-item-title>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showMenuModelle"
        :close-on-content-click="false"
        :persistent="closeOnOutside"
        min-width="80"
        v-if="modelle && modelle.length > 0"
        location="bottom"
        @click:outside="showMenuModelle = false"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            :base-color="color ?? 'black'"
            variant="text"
            v-bind="props"
            icon="mdi-play-circle-outline"
          >
          </v-btn>
        </template>
        <v-list class="shortList" nav tile outlined elevation="12">
          <v-list-item
            v-for="(modellItem, index) in modelle"
            :key="'ui' + index"
            class="pl-2"
          >
            <CalcButton
              :text="modellItem.bezeichnung"
              :modell="modellItem.kennung"
              :icon="modellItem.icon ?? 'mdi-play-circle-outline'"
              :color="modellItem.farbe"
              variant="plain"
              :vecStamm="vectorMutable"
              :useVecStamm="onlyVectorMutable"
              @calculated="onCalculated"
              :zeitbereich="props.zeitbereich"
            />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu :close-on-content-click="true" v-if="frame && frame.length > 0">
        <template v-slot:activator="{ props }">
          <v-btn
            color="white"
            variant="text"
            v-bind="props"
            icon="mdi-open-in-new"
          ></v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in frame" :key="'p' + index">
            <v-btn variant="text" @click="openFrame(item)" icon="mdi-open-in-new">
              {{ item.bezeichnung }}</v-btn
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        variant="text"
        icon="mdi-swap-vertical"
        color="white"
        @click.stop="showExport = !showExport"
        v-if="exportItems"
        style="z-index: 99999"
      >
      </v-btn>
      <v-dialog leave-absolute="true" max-width="600px" v-model="showExport" scrollable>
        <BaseApiAufruf
          @back="showExport = false"
          :exportAbfragen="exportItems"
          title="Export"
          type="month"
          :vecStamm="vector"
        >
        </BaseApiAufruf>
      </v-dialog>
    </div>
  </div>
</template>
